/** Constantes representando seletores para o cookiebar */
export const POLITICS_BUTTON = '.actions .br-button.secondary'
export const ACCEPT_BUTTON = '.actions .br-button.primary'
export const ACTION_BUTTONS = `${POLITICS_BUTTON}, ${ACCEPT_BUTTON}`
export const CLOSE_BUTTON = '.br-modal-header .br-button.close'
export const CONTAINER_FLUID = '.br-modal > .br-card .container-fluid'
export const WRAPPER = '.br-modal > .br-card .wrapper'
export const MODAL_FOOTER = '.br-modal > .br-card .br-modal-footer'
export const GROUP_INFO = '.main-content .group-info'
export const COOKIE_CARD = '.main-content .cookie-info .br-card'
export const BROAD_ALERT =
  '.header .row:nth-child(1) div:nth-child(3) .feedback'
export const GROUP_ALERT = '.row:nth-child(1) div:nth-child(4) .feedback'
export const COOKIE_ALERT = '.row:nth-child(1) div:nth-child(2) .feedback'
export const BR_CHECKBOX = '.br-checkbox input[type="checkbox"]'
export const BR_SWITCH = '.br-switch input[type="checkbox"]'
export const CHECKBOX = `${BR_CHECKBOX}, ${BR_SWITCH}`
export const PARENT_CHECKBOX = '.main-content .br-checkbox input[data-parent]'
export const COOKIES_CHECKED = '.main-content .br-item .cookies-checked'
export const GROUP_BUTTON = '.main-content .br-item .br-button'
export const GROUP_NAME = '.main-content .br-item .group-name'
export const GROUP_SIZE = '.main-content .br-item .group-size'
export const BUTTON_ICON = '.br-button i.fas'
